let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("19dZT")).then(() => parcelRequire('gxfVm'));